import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import AudioLoadingDescription from '../../components/Accessibility/AudioLoadingDescription';
import CircularProgressLoading from '../../components/Accessibility/CircularProgressLoading';
import ModalFeedBack from '../../components/ModalFeedBack';
import { UnimedContact } from '../../interfaces/entities/FaleComUnimed/UnimedContact';
import { getTelefonesUteis } from '../../services/ConfigService';
import ContactCard from './ContactCard';
import './styles.css';
import { sxTitle } from './sxProps';
import PageTitle from '../../components/Accessibility/PageTitle';

const FaleComUnimed: React.FC = () => {

  const accessibility = useAccessibility();

  const [loading, setLoading] = useState<boolean>(false);
  const [unimedContact, setUnimedContact] = useState<UnimedContact[]>();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const fetchUnimedContactData = async () => {
    setLoading(true);
    const response = await getTelefonesUteis();
    if (response?.status === 200) {
      setUnimedContact(response.data);
    } else {
      console.error(response);
      openModalError('Erro ao consultar meios de contato', 'Ocorreu um erro ao consultar os contatos da Unimed. Tente novamente em instante.');
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchUnimedContactData();
  }, []);

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  return (
    <>
      <div className='feature-container' aria-atomic>
        <AudioLoadingDescription loading={loading} />
        <PageTitle text="Fale com a Unimed" />
        {loading && <CircularProgressLoading />}
        <div className='unimed-contacts-holder'>
          {unimedContact?.map((contact) => (
            <ContactCard contato={contact} key={contact.title} />
          ))
          }
        </div>
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default FaleComUnimed;